import { Action } from 'redux';
import { SalesData } from 'src/types/model';

export const FETCH_SALES_REQUEST = 'FETCH_SALES_REQUEST';
export const FETCH_SALES_SUCCESS = 'FETCH_SALES_SUCCESS';
export const FETCH_SALES_FAILURE = 'FETCH_SALES_FAILURE';
export const FETCH_PAYMENT_SUCCESS = 'FETCH_PAYMENT_SUCCESS';
export const FETCH_ORDER_TYPES_SUCCESS = 'FETCH_ORDER_TYPES_SUCCESS';

export interface FetchSalesRequestAction
  extends Action<typeof FETCH_SALES_REQUEST> {}

export interface FetchSalesSuccessAction
  extends Action<typeof FETCH_SALES_SUCCESS> {
  payload: SalesData;
}

export interface fetchPaymentSuccess
  extends Action<typeof FETCH_PAYMENT_SUCCESS> {
  payload: any;
}

export interface FetchSalesFailureAction
  extends Action<typeof FETCH_SALES_FAILURE> {
  payload: string;
}

export interface FetchOrderTypesSuccessAction
  extends Action<typeof FETCH_ORDER_TYPES_SUCCESS> {
  payload: any;
}

export type SalesActionType =
  | FetchSalesRequestAction
  | FetchSalesSuccessAction
  | FetchSalesFailureAction
  | FetchOrderTypesSuccessAction
  | fetchPaymentSuccess;
